export function getCookie(name) {
  const m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
  return m ? decodeURIComponent(m[1]) : undefined;
}

export function getTrackingFields() {
  let sourceId;
  try {
    const raw = getCookie('_src');
    if (raw) sourceId = JSON.parse(raw).source_id;
  } catch (e) {}
  const gaRaw = getCookie('_ga');
  const gaClientId = gaRaw ? gaRaw.replace(/^GA1\.\d\./, '') : undefined;
  return {
    sourceId,
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    gaClientId
  };
}
